import { useSelector } from 'react-redux';
import { ReduxState } from 'redux/store';

/**
 * Charter business ERP ID - consistent across all environments.
 * Note: Business UUIDs differ by environment, so we check by ERP ID.
 */
const CHARTER_BUSINESS_ERP_ID = 'CHAR000';

/**
 * Hook to check if the currently selected business is Charter.
 * Used to conditionally show Charter-specific UI elements.
 *
 * @returns Object containing isCharter boolean and the business details
 */
export const useIsCharterBusiness = () => {
  const { selectedBusiness } = useSelector((state: ReduxState) => state.selectedBusiness);

  const isCharter = selectedBusiness?.erpId?.toUpperCase() === CHARTER_BUSINESS_ERP_ID;

  return {
    isCharter,
    businessName: selectedBusiness?.name,
    businessErpId: selectedBusiness?.erpId
  };
};
